import { InjectionToken, inject } from '@angular/core';
import { LiveHubService } from './live.hub.service';

export const LIVE_SIGNALR_HUB = new InjectionToken<LiveHubService>(
    'LIVE_SIGNALR_HUB',
    {
        providedIn: 'root',
        factory: () => inject(LiveHubService),
    },
);
